import * as React from 'react';

function AppleIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6975 16.4199C17.8945 15.9809 17.3335 15.2129 17.1555 14.2969C16.8745 13.0639 17.3625 11.7909 18.4175 11.0419C18.5225 10.9589 18.7705 10.7659 18.7985 10.4439C18.8265 10.1279 18.6235 9.89988 18.5685 9.83888C17.5775 8.64788 16.0135 8.07288 14.4905 8.34688C13.9405 8.44188 13.3955 8.61288 12.8675 8.85688C12.3945 9.08088 11.8355 9.07088 11.3755 8.83488C9.34949 7.77588 6.84049 8.47688 5.66049 10.4339C4.99449 11.4659 4.67349 12.7149 4.75449 13.9199C4.75849 15.1069 4.98249 16.2739 5.41549 17.3789C5.90949 18.7459 6.69249 20.0169 7.64349 21.0139C8.14249 21.6629 8.90149 22.0109 9.66649 22.0099C10.1035 22.0099 10.5425 21.8969 10.9355 21.6619C11.7645 21.2269 12.7665 21.2089 13.5645 21.5819C14.8045 22.3569 16.4265 22.0229 17.2195 20.8689C18.0635 19.9059 18.7125 18.8169 19.1515 17.6199C19.3675 17.0109 19.2725 16.7539 18.6975 16.4199Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0359 7.98834H12.0429C13.2669 7.97134 14.3339 7.48234 15.0479 6.60834C15.7559 5.74034 16.0209 4.60634 15.7949 3.41534C15.7479 3.16734 15.5179 2.98934 15.2719 3.00934C14.1329 3.08134 13.1189 3.58334 12.4179 4.42534C11.7059 5.27734 11.3909 6.38634 11.5289 7.54834C11.5589 7.79934 11.7829 7.98834 12.0359 7.98834Z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoAppleIcon = React.memo(AppleIcon);
export default MemoAppleIcon;
